<template>
  <v-row dense justify="center" align="center">
    <v-col cols="12">
      <v-expansion-panels outlined v-model="panel_open">
        <v-expansion-panel>
          <v-expansion-panel-header disable-icon-rotate>
            <template v-slot:actions>
              <v-tooltip v-if="!required" top color="black">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="warning"> mdi-alert-circle </v-icon>
                </template>
                <span>{{
                  $t("messanger.dash.filters.state_mode.required")
                }}</span>
              </v-tooltip>
              <v-icon v-else color="success"> mdi-check-circle </v-icon>
              <v-icon color="primary"> $expand </v-icon>
            </template>
            <template v-slot:default="{ open }">
              <v-row no-gutters align="center">
                <v-col cols="8">
                  <v-row dense no-gutters align="center">
                    <v-col cols="auto">
                      <v-btn x-small icon class="mr-2" disabled>
                        <v-img
                          src="@/assets/smart_toy.svg"
                          class="filters-icons"
                        />
                      </v-btn>
                    </v-col>
                    <v-col cols="9">
                      <strong>
                        {{ $t("messanger.dash.filters.Bot_Human_mode.name") }}
                      </strong>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0">
                      {{
                        $t(
                          "messanger.dash.filters.Bot_Human_mode.select_choise"
                        )
                      }}
                    </span>
                    <span v-else key="1">
                      {{
                        selected_mode
                          ? $t(
                              `messanger.dash.filters.Bot_Human_mode.${selected_mode}`
                            )
                          : ""
                      }}
                      {{
                        in_mode_selected
                          ? `, ${$t(
                              `messanger.dash.filters.Bot_Human_mode.${in_mode_selected}_mode`
                            )}`
                          : ""
                      }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense no-gutters justify="center" align="center">
              <v-col cols="auto">
                <v-row justify="center" align="center">
                  <v-radio-group
                    @change="update_chat_mode('mode')"
                    v-model="selected_mode"
                    columns
                    light
                  >
                    <v-row dense justify="center" align="center">
                      <v-col cols="auto">
                        <v-radio
                          :label="
                            $t('messanger.dash.filters.Bot_Human_mode.auto')
                          "
                          color="#1141ce"
                          value="auto"
                          class="px-3"
                          disabled
                        ></v-radio>
                      </v-col>
                      <v-col cols="auto">
                        <v-radio
                          :label="
                            $t('messanger.dash.filters.Bot_Human_mode.manual')
                          "
                          color="#1141ce"
                          value="manual"
                          class="px-3"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-row>
              </v-col>

              <v-fade-transition hide-on-leave>
                <v-col v-if="selected_mode === 'auto'" cols="12">
                  <DateSet />
                </v-col>
              </v-fade-transition>
              <v-fade-transition hide-on-leave>
                <v-col v-if="selected_mode === 'manual'" cols="12">
                  <v-row justify="center" align="center">
                    <v-col cols="12" sm="8">
                      <v-select
                        light
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="in_mode_selected"
                        :items="modes"
                        @change="update_chat_mode('state')"
                      >
                        <template v-slot:label>
                          <v-icon size="22" class="mx-1" color="black">
                            mdi-robot-happy
                          </v-icon>
                          {{
                            $t("messanger.dash.filters.Bot_Human_mode.modes")
                          }}
                        </template>
                        <template slot="selection" slot-scope="{ item }">
                          {{
                            $t(
                              `messanger.dash.filters.Bot_Human_mode.${item.text}`
                            )
                          }}
                        </template>
                        <template v-slot:item="{ item }">
                          <span>
                            {{
                              $t(
                                `messanger.dash.filters.Bot_Human_mode.${item.text}`
                              )
                            }}
                          </span>
                          <span class="ml-1 text--disabled">
                            {{
                              item.value == "bot" && item.disabled
                                ? "(LLM config required)"
                                : ""
                            }}
                          </span>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-fade-transition>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import DateSet from "@/components/settings/ConfigModeDate.vue";
export default {
  components: {
    DateSet,
  },
  data() {
    return {
      modes: [
        { text: "human_mode", value: "human", disabled: false },
        { text: "bot_mode", value: "bot", disabled: false },
      ],
      panel_open: false,
      selected_mode: null,
      in_mode_selected: null,
    };
  },
  computed: {
    config() {
      return this.$store.state.store_config.store.chat_config;
    },
    openAiConfig() {
      return this.$store.state.llm_config.config;
    },
    required() {
      return (
        this.config?.chat_mode?.state === "bot" ||
        this.config?.chat_mode?.state === "human"
      );
    },
  },
  async mounted() {
    await this.getLlmConfig();
    //disable bot mode if LLM config is not set
    if (!this.openAiConfig) {
      this.modes[1].disabled = true;
    }

    if (this.config?.chat_mode?.mode) {
      if (this.config?.chat_mode?.mode === "manual")
        this.selected_mode = "manual";
      else if (this.config?.chat_mode?.mode === "auto")
        this.selected_mode = "auto";
      else this.selected_mode = null;
    } else this.selected_mode = null;

    if (this.config.chat_mode?.state) {
      this.in_mode_selected = this.config.chat_mode?.state || null;
    }
  },
  methods: {
    async getLlmConfig() {
      try {
        // this.loading = true;
        await this.$store.dispatch("FETCH_LLM_CONFIG");
        return this.$store.state.llm_config.config;
      } catch (error) {
        console.log("error", error);
        return null;
      }
    },
    async update_chat_mode(type) {
      try {
        console.log("main mode is:", this.selected_mode);

        const confirmation = await this.$store.dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: this.$t("show_box.agree"),
          ligth: false,
        });

        if (!confirmation) {
          if (type === "mode")
            this.selected_mode = this.config?.chat_mode?.mode;
          else this.in_mode_selected = this.config?.chat_mode?.state;
          return;
        }
        if (type === "mode") {
          this.config.chat_mode = {
            ...this.config.chat_mode,
            mode: this.selected_mode,
          };
          this.config.chat_mode.state = null;
        } else {
          this.config.chat_mode = {
            ...this.config.chat_mode,
            state: this.in_mode_selected,
          };
        }
        this.config.chat_state = {};
        const new_config = await this.$store.dispatch("UPDATE_CHAT_CONFIG", {
          chat_config: this.config,
        });
        if (new_config) {
          this.$socket.emit("UPDATE_CHAT_CONFIG_SOCKET", new_config);
          this.in_mode_selected = new_config.chat_mode.state;
          this.selected_mode = new_config.chat_mode.mode;
        }
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: this.$t("store.snackbar_text"),
          color: "success",
          timeout: 1000,
        });
      } catch (error) {
        console.log("error", error);
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: error.response.data,
          color: "error",
          timeout: 1000,
        });
      }
    },
  },
};
</script>
